import React, { useState } from 'react';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Logo from '../../components/Logo';
import { Loader2, ArrowUpRight, ArrowLeft } from 'lucide-react';

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(email, password);
      nav('/admin');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Invalid credentials');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex">
      <aside className="hidden lg:flex flex-col justify-between w-1/2 bg-[#0F0F10] text-white p-10 grain relative overflow-hidden">
        <Logo variant="light" />
        <div className="relative z-10">
          <h1 className="heading-display text-[56px] leading-[0.95]">ClicksyHub <span className="heading-serif-italic" style={{ color: '#F4E94B' }}>Console</span></h1>
          <p className="mt-6 text-white/70 max-w-md">Manage content, languages, countries, users and roles for the public site. Everything you change here goes live instantly.</p>
        </div>
        <p className="text-white/50 text-sm relative z-10">© 2025 ClicksyHub LLC</p>
        <div className="absolute -right-20 top-1/3 w-72 h-72 rounded-full bg-[#1E2DFF] opacity-30 blur-3xl" />
        <div className="absolute right-10 bottom-10 w-40 h-40 rounded-full bg-[#F4E94B] opacity-20 blur-2xl" />
      </aside>
      <main className="flex-1 flex items-center justify-center p-6 admin-bg">
        <form onSubmit={submit} className="w-full max-w-[440px]">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-stone-600 hover:text-[#0F0F10] mb-8"><ArrowLeft size={14} /> Back to website</Link>
          <h2 className="heading-display text-3xl">Sign in to the console</h2>
          <p className="mt-2 text-stone-600">Use your ClicksyHub admin credentials.</p>
          <label className="block mt-8">
            <span className="text-sm font-medium text-stone-700">Email</span>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="mt-2 w-full rounded-2xl border border-black/15 bg-white px-4 py-3 text-[15px] focus:outline-none focus:ring-2 focus:ring-[#0F0F10]" />
          </label>
          <label className="block mt-4">
            <span className="text-sm font-medium text-stone-700">Password</span>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="mt-2 w-full rounded-2xl border border-black/15 bg-white px-4 py-3 text-[15px] focus:outline-none focus:ring-2 focus:ring-[#0F0F10]" />
          </label>
          {error && <p className="mt-3 text-sm text-red-600">{error}</p>}
          <button type="submit" disabled={loading} className="btn-pill mt-6 w-full justify-center">
            {loading ? <Loader2 className="animate-spin" size={16} /> : <span>Sign in</span>}
            <span className="arrow"><ArrowUpRight size={14} /></span>
          </button>
        </form>
      </main>
    </div>
  );
}
